import styled from 'styled-components';

import { ReactComponent as AddIcon } from '../../../../../../../../assets/icons/v2/add-yellow.svg';
import colors from '../../../../../../../../styles/colors';

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: start;
  gap: 5px;
`;

const StyledAddIcon = styled(AddIcon)`
  width: 20px;
  height: 20px;
  fill: ${colors.shades.secondary7};
`;

export {
  StyledAddIcon,
  ButtonContainer,
};
